import { render, staticRenderFns } from "./GlaxiFooterNewsletter.vue?vue&type=template&id=0f8d114c&"
import script from "./GlaxiFooterNewsletter.vue?vue&type=script&lang=js&"
export * from "./GlaxiFooterNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./GlaxiFooterNewsletter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports